
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-product-feature-item',
    templateUrl: './product-feature-item.html',
    styleUrls: ['./product-feature-item.scss'],
    standalone: false
})

export class ProductFeatureItemComponent implements OnInit {
    @Input() header: string;
    @Input() message: string;
    @Input() buttonTitle: string;
    @Input() headerIcon: string;
    @Input() externalUrl: string;
    @Input() buttonUrl: string;
    @Input() hasPermission: boolean = true;
    @Input() id: string;

    readonly buttonTypes = ButtonTypesEnum;

    constructor (private router: Router) {}

    openTab(url: string) {
        if (this.hasPermission) {
            this.router.navigate([url]);
        } else {
            window.open(url, '_blank');
        }
    }

    ngOnInit(): void {}
}
